import { Button, Card, Grid, InputLabel, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomInput from '../../../Components/CustomInput';
import CustomSelect from '../../../Components/CustomSelect'
import Header from './header';
import AdminPartnerClient from '../../../Service/Admin/partner_services'
import CustomTimePicker from '../../../Components/CustomTimePicker';
import { ObjectToFormdata } from '../../../Common/Utils/common_utils';
import { GLOBAL_STEPPER_DATA } from '../../../Redux/actions';
import { Cancel, CloudUpload } from '@material-ui/icons';
import AddToListModal from "../../../Components/FormGenerator/addToListModal";
import { showSnackbar } from '../../../Components/Snackbar/SnackbarActions'
import DateComponent from '../../../Components/FormGenerator/datepicker_component';
import StepperService from './StepperService';
import { mappedKeyJSON } from './MappedKeyJSON';
import CircularIndeterminate from '../../../Components/Loader';
import { useHistory } from 'react-router';
import CustomSelectMulti from '../../../Components/CustomSelectMulti';


const Gdpr = (props: any) => {
  const classes = useStyles();
  const today = new Date();
  const data = {
    consent_status: "true",
    consent_expiry_date: `${new Date(
      today.setFullYear(today.getFullYear() + 2)
    )}`,
    consent_terms: "",
    lawful_bia_id: "Coaching",
    // purpose_id: "",
    contact_status_id: "Do not contact",
  };
  const [userData, setUserData] = useState(data);
  const [lawfulBiaArr, setLawfulBiaArr]: any = useState([]);
  const [contactStatusArr, setContactStatusArr]: any = useState([]);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [submitText, setSubmiText] = React.useState("Save and Proceed");
  const [loading, setLoading] = useState(false);
  const [purposeArr, setPurposeArr]: any = useState([]);
  // let defaultPurpose:any=[];
  const [purposeArr_attribute, setPurposeArr_attribute]: any = useState([]);

  useEffect(() => {
    if (purposeArr.length > 0) {
      setPurposeArr_attribute(
        purposeArr.filter((el: any) => el.value === "Legitimate interest")
      );
    }
  }, [purposeArr]);

    //  const globaluserData = useSelector((state) => state.commonReducer);
    //  let role = globaluserData?.role;
  let role = sessionStorage.getItem("role");
  console.log("user data", purposeArr_attribute);
  const global_data = useSelector((state: any) => state.stepperReducer);
  const global_data_common = useSelector((state: any) => state.commonReducer);
  const dispatch = useDispatch();
  const history = useHistory();

  const setInputState = (inputStateValue: any, inputId: any) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
    console.log(inputStateValue);
  };
  const onChangeItem = (selectedItemValue: any) => {
    if (selectedItemValue.id == "consent_status") {
      selectedItemValue.value =
        selectedItemValue.value == ""
          ? ""
          : selectedItemValue.value == "Yes"
          ? "true"
          : "false";
    }
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };

  const onChangeMultiItem = (
    obj: any,
    inputId: any,
    routeFrom: any,
    objId: any
  ) => {
    console.log(obj, inputId, routeFrom);
    if (routeFrom == "add_in_drop_down") {
    } else {
      if (inputId == "purposeArr_attribute") {
        purposeArr_attribute.length = 0;
        setPurposeArr_attribute(purposeArr_attribute.concat(obj));
      }
    }
  };
  const firstElementRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.LawfulBia],
      setLawfulBiaArr,
      lawfulBiaArr
    );
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.Purpose],
      setPurposeArr,
      purposeArr
    );
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.ContactStatus],
      setContactStatusArr,
      contactStatusArr
    );
    purposeArr.length = 0;
    setPurposeArr(
      purposeArr.concat(
        global_data_common.partnerDropdowns[mappedKeyJSON.Purpose]
      )
    );

    if (global_data.gdprs_id != null) {
      setLoading(true);
      AdminPartnerClient.gdprs(
        global_data.gdprs_id,
        { partner_profile_id: global_data.partner_profile },
        "GET"
      )
        .then((response: any) => {
          setUserData({
            consent_status:
              response.data.attributes.consent_status != null
                ? response.data.attributes.consent_status
                  ? "true"
                  : "false"
                : "",
            consent_expiry_date: response.data.attributes.consent_expiry_date,
            consent_terms: response.data.attributes.consent_terms,
            lawful_bia_id: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.LawfulBia],
              response.data.attributes.lawful_bia_id
            ),
            contact_status_id: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.ContactStatus],
              response.data.attributes.contact_status_id
            ),
            // purpose_id: StepperService.getValueFromArrById(global_data_common.partnerDropdowns[mappedKeyJSON.Purpose], response.data.attributes.purpose_id),
          });
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.purpose_ids,
            global_data_common.partnerDropdowns[mappedKeyJSON.Purpose],
            setPurposeArr_attribute,
            purposeArr_attribute
          );
          setLoading(false);
        })
        .catch((error) => {
          dispatch(showSnackbar("error", ["" + JSON.stringify(error.errors)]));
          setLoading(false);
        });
    }
  }, []);

  const onSubmit = () => {
    if (submitText == "Complete") {
      history.goBack();
    } else {
      var flag = true;
      if (
        role == "admin" &&
        (userData.consent_status == "" ||
          userData.consent_expiry_date == "" ||
          userData.consent_expiry_date === null ||
          userData.consent_terms == "" ||
          userData.lawful_bia_id == "" ||
          // userData.purpose_id == "" ||
          userData.contact_status_id == "" ||
          purposeArr_attribute.length == 0)
      ) {
        flag = false;
      }
      if (flag) {
        var purposeArr: any = [];
        purposeArr_attribute.length > 0 &&
          purposeArr_attribute.map((option: any) => purposeArr.push(option.id));

        var postData = {
          ...userData,
          consent_status: userData.consent_status == "true" ? true : false,
          partner_profile_id: global_data.partner_profile,
          lawful_bia_id: StepperService.getSelectedIdFromArr(
            global_data_common.partnerDropdowns[mappedKeyJSON.LawfulBia],
            userData.lawful_bia_id
          ),
          purpose_ids:
            purposeArr_attribute.length > 0 ? JSON.stringify(purposeArr) : "[]",
          //   purpose_id: StepperService.getSelectedIdFromArr(global_data_common.partnerDropdowns[mappedKeyJSON.Purpose], userData.purpose_id),
          contact_status_id: StepperService.getSelectedIdFromArr(
            global_data_common.partnerDropdowns[mappedKeyJSON.ContactStatus],
            userData.contact_status_id
          ),
        };
        setSubmitClickFlag(false);
        setLoading(true);
        if (global_data.gdprs_id == null) {
          AdminPartnerClient.gdprs("", { ...postData }, "POST")
            .then((response: any) => {
              dispatch({
                type: GLOBAL_STEPPER_DATA,
                payload: { gdprs_id: response.data.id },
              });
              // props.parentHandleNext(props.activeIndex + 1)
              setSubmiText("Complete");
              dispatch(
                showSnackbar("Success", ["Information saved successfully"])
              );
              setLoading(false);
            })
            .catch(() => {
              setLoading(false);
            });
        } else {
          AdminPartnerClient.gdprs(global_data.gdprs_id, { ...postData }, "PUT")
            .then(() => {
              // props.parentHandleNext(props.activeIndex + 1)
              setSubmiText("Complete");
              dispatch(
                showSnackbar("Success", ["Information updated successfully"])
              );
              setLoading(false);
            })
            .catch((error) => {
              dispatch(
                showSnackbar("error", ["" + JSON.stringify(error.errors)])
              );
              setLoading(false);
            });
        }
      } else {
        setSubmitClickFlag(true);
      }
    }
  };

  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };
  return (
    <div style={{ marginBottom: 40 }} ref={firstElementRef}>
      {/* <Header parentcall={onSubmit} /> */}
      <Grid
        container
        direction='row'
        alignItems='flex-start'
        style={{ padding: 30, marginBottom: 30 }}
      >
        <Grid item xs={10}>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Consent status{role == "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelect
                labelText='Select consent status'
                id='consent_status'
                displayEmpty
                variant='outlined'
                itemArr={["Yes", "No"]}
                defaultValue={
                  userData.consent_status != ""
                    ? userData.consent_status == "true"
                      ? "Yes"
                      : "No"
                    : "0"
                }
                helperText={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.consent_status == ""
                    ? "* Please select consent status"
                    : ""
                }
                error={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.consent_status == ""
                    ? true
                    : false
                }
                parentcall={onChangeItem}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 10 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Consent expiry date{role == "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <DateComponent
                key={"011"}
                componentObject={{
                  componentType: "datePicker",
                  required: true,
                  label: "",
                  name: "consent_expiry_date",
                  placeholder: "DD/MM/YYYY",
                  helperText:
                    role == "admin" &&
                    submitClickFlag &&
                    (userData.consent_expiry_date == "" ||
                      userData.consent_expiry_date === null) ? (
                      <span style={{ marginLeft: "-0.9rem" }}>
                        {"* Please enter consent expiry date"}
                      </span>
                    ) : (
                      false
                    ),
                  indexKey: "0-0",
                  index: "consent_expiry_date",
                  handleChange: setInputState,
                  value: userData.consent_expiry_date,
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Consent terms{role == "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='consent_terms'
                variant='outlined'
                placeholder='Consent terms'
                multiline={true}
                rows={4}
                parentcall={setInputState}
                value={userData.consent_terms}
                error={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.consent_terms == ""
                    ? true
                    : false
                }
                helperText={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.consent_terms == ""
                    ? "* Please enter consent expiry date"
                    : false
                }
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Lawful bias{role == "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelect
                labelText='Select lawful bias'
                id='lawful_bia_id'
                displayEmpty
                variant='outlined'
                itemArr={lawfulBiaArr}
                defaultValue={userData.lawful_bia_id}
                helperText={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.lawful_bia_id == ""
                    ? "* Please select lawful bias"
                    : ""
                }
                error={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.lawful_bia_id == ""
                    ? true
                    : false
                }
                parentcall={onChangeItem}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Purposes{role == "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelectMulti
                id='purposeArr_attribute'
                itemArr={purposeArr}
                parentcall={onChangeMultiItem}
                placeholder='Select purpose'
                helperText={
                  submitClickFlag &&
                  role == "admin" &&
                  purposeArr_attribute.length == 0
                    ? "Please select purpose"
                    : ""
                }
                error={
                  submitClickFlag &&
                  role == "admin" &&
                  purposeArr_attribute.length == 0
                    ? true
                    : false
                }
                value={purposeArr_attribute}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Contact status (do not contact, do not mailshot etc)
                {role == "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelect
                labelText='Select contact status'
                id='contact_status_id'
                displayEmpty
                variant='outlined'
                itemArr={contactStatusArr}
                helperText={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.contact_status_id == ""
                    ? "* Please select contact status"
                    : ""
                }
                error={
                  role == "admin" &&
                  submitClickFlag &&
                  userData.contact_status_id == ""
                    ? true
                    : false
                }
                defaultValue={userData.contact_status_id}
                parentcall={onChangeItem}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Header
        saveBtnTitle={submitText}
        isBack={true}
        parentcall={onSubmit}
        parentBackCall={onBack}
      />
      {loading && <CircularIndeterminate />}
    </div>
  );
}
export default Gdpr
const useStyles = makeStyles((theme) => ({
    labelText: {
        color: '#4D4F5C',
        fontSize: '16px',
        lineHeight: '22px',
        paddingRight: '10px'
    },
}))
